module.exports = __webpack_public_path__ + "media/images/icons/icon-down-arrow-2384725e5cb7caba76fcaa58501476c0.png";